import { fileMixin } from './FileMixin';

export var fileMixinSound = {
    mixins: [fileMixin],
    data: () => ({
        soundData: { path: '', name: '' },
        soundOptional: false,
        soundFiles: [],
        soundTypes: ['.mp3'],
        soundValid: true
    }),
    computed: {
        soundRules: function () {
            return [
                value => {
                    let required = !(this.soundOptional || !(!value || (Array.isArray(value) && !value[0])));
                    return required ? 'Fichier requis' : true;
                },
                value => {
                    let extension = value ? this.getExtension(value.name) : '';
                    let allTypes = this.soundTypes.reduce((acc, item) => acc + ' *' + item, '');
                    let required = !(this.soundOptional && extension === '');
                    let extensionValid = !this.soundTypes.includes('.' + extension);
                    return required && extensionValid ? 'Formats attendus:' + allTypes : true;
                },
                value => {
                    let required = !(this.soundOptional && !value);
                    let validSize = !(value && value.size < 4000000);
                    return required && validSize ? 'La taille du fichier doit être inférieur à 4 MB!' : true;
                }
            ];
        }
    },
    watch: {
        soundValid: function (newValue) {
            this.$emit('validate', newValue);
        }
    },
    methods: {
        initSoundFiles: function (file, path, optional = false) {
            this.soundOptional = optional;
            if (file && file.path !== undefined) {
                this.createFile(path + file.path, file.name).then((data) => {
                    this.soundFiles = data;
                    this.soundValid = this.validateSound(this.soundFiles);
                });
            }
        },
        validateSound: function (sound) {
            return this.soundRules.reduce((acc, item) => acc && item(sound) && typeof item(sound) !== 'string', true);
        },
        onChangeSound: function (sound) {
            if (!sound && this.soundOptional) {
                this.soundData = { path: '', name: '' };
                this.soundValid = true;
                return;
            }
            this.soundValid = this.validateSound(sound);
            this.onChangeFile(sound, this.soundValid).then((data) => {
                this.soundFiles = data.file;
                this.soundData = data.shortFile;
            }).catch((err, data) => {
                this.$toasted.error(err);
                this.soundData = data;
            });
        }
    }
};
